export default __webpack_public_path__ + "static/media/save-collection.93027dbd.svg";